import styled from '@emotion/styled/macro';
import vars from '@variables';
import { TileTagsContainer } from './tile-tags';
import { PAtom } from '@atoms/text-atoms/text-atoms';
import { FlexibleLinkAtom } from '@atoms/link-atoms/link-atoms';

export const TileContentContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  ${TileTagsContainer} {
    margin-top: ${vars.spacingXs};
  }
`;

interface TileDescriptionProps {
  hideDesc?: boolean;
}
export const TileDescription = styled(PAtom)<TileDescriptionProps>`
  ${vars.fontSize2};
  line-height: 1.4;
  margin-top: 4px;
  padding: 0;
`;

export const TileTitleH2 = styled.h2`
  padding: 0;
  margin-top: 4px;
  ${vars.fontSize5}
  font-weight: ${vars.fontWeightBold};
  letter-spacing: -0.02em;
  padding-bottom: ${vars.spacingS};
`;

export const TileTitleH3 = styled.h3`
  padding: 0;
  margin-top: 4px;
  ${vars.fontSize5}
  font-weight: ${vars.fontWeightBold};
  letter-spacing: -0.02em;
  padding-bottom: ${vars.spacingS};
`;

interface TileImageContainerProps {
  tileType: string;
  localeUnavailable: boolean;
  isCompact?: boolean;
}
export const TileImageContainer = styled.div<TileImageContainerProps>`
  position: relative;
  width: 100%;
  opacity: ${({ localeUnavailable }) => (localeUnavailable ? 0.6 : 1)};
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  margin-bottom: ${vars.spacingXs};

  // this hack maintains the 16:9 ratio and prevents images from being cut off
  // we only need this for large tiles where image might not be 16:9 or has enough width or height. if a tile is compact, we don't need this since image will be small enough
  ${({ isCompact }) => !isCompact && 'height: 0; padding-bottom: 56.25%;'}

  .gatsby-image-wrapper,
  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TileContentInfo = styled.div`
  ${vars.fontSize1};
  color: ${vars.coreDarkGrey};
  margin-top: ${vars.spacingXs};
`;

interface TileContainerProps {
  tileType: string;
  isCompact?: boolean;
}
export const TileContainer = styled.div<TileContainerProps>`
  overflow: hidden;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  background: white;
  width: 100%;
  height: auto;

  a {
    text-decoration: none;
    overflow: hidden;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
  }

  ${FlexibleLinkAtom} {
    ${({ isCompact }) =>
      isCompact && 'flex-direction: row; gap: 1rem; align-items: flex-start;'}

    img {
      transition: ${vars.defaultTransition};
    }

    :hover {
      img {
        transform: ${vars.imageHoverScale};
        transition: ${vars.defaultTransition};
      }
    }
  }

  ${TileDescription} {
    @media screen and (max-width: ${vars.breakPointTablet}) {
      display: ${({ isCompact }) => (isCompact ? 'none' : 'block')};
    }
  }
`;
